import React, { useState } from "react";
import downloadIcon from "../../../../assets/icons/new_icon/download.svg";
interface Props {
  data: any;
  fetchDocs: (line_no: any) => void;
}
function HistoryListing({ data, fetchDocs }: Props) {
  return (
    <div className="ubbe-card accordion-border">
      <div
        className="accordion accordion-flush"
        style={{ backgroundColor: "transparent" }}
        id="shipment_document_accordion"
      >
        <div
          className="accordion-item border"
          style={{ backgroundColor: "transparent" }}
        >
          <h2 className="accordion-header" id="main_document_head">
            <div className="row align-items-center position-relative ">
              <div
                className="col-auto position-absolute z-3"
                style={{
                  right: "45px",
                  zIndex: "9999",
                  display: "flex",
                  justifyContent: "center",
                }}
              ></div>
              <div className="col">
                <button
                  className={`accordion-button  col-12 
               "active"
                  }`}
                  style={{ backgroundColor: "#251163" }}
                  type="button"
                >
                  <h5
                    style={{ color: "white" }}
                    className="accordion-header boldsteppertext"
                    id="shipment_document_head"
                  >
                    Documents{" "}
                  </h5>
                </button>
              </div>
            </div>
          </h2>

          <div
            id="main_document_body"
            className={`accordion-collapse collapse ${"show"}`}
            aria-labelledby="main_document_head"
            data-bs-parent="#main_leg_accordion"
          >
            <div className="accordion-body p-0 mt-2">
              <table
                className="table table-striped mb-0"
                id="shipment_document_table"
              >
                <thead className="ubbe-table-header">
                  <tr>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      scope="col"
                      style={{ width: "42%" }}
                    >
                      Name
                    </th>

                    <th></th>
                  </tr>
                </thead>
                <tbody id="shipment_document_rows">
                  {data && data.length > 0 ? (
                    data.map((item: any) => (
                      <tr data-document={`${JSON.stringify(data)}`}>
                        <td className="align-middle">{item?.description}</td>

                        <td className="text-end align-items-end justify-content-end">
                          {/* {item?.document && ( */}
                          <a
                            className="btn-ubbe-no-style px-1 d-flex  align-items-center justify-content-end"
                            // href={`data:application/pdf;base64,${item["document"]}`}
                            // download={`${item["file_name"]}`}
                            target="_blank"
                            rel="noreferrer"
                            style={{ cursor: "pointer" }}
                            onClick={() => fetchDocs(item)}
                          >
                            <img
                              alt="delete-icon"
                              src={downloadIcon}
                              className="packageBoxIcon"
                              style={{
                                backgroundColor: "#31BC0E1A",
                                width: "32px",
                              }}
                            />
                            Download
                          </a>
                          {/* )} */}
                        </td>
                        {/* <td></td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={9}
                        className="text-center global-text align-middle"
                        style={{ color: " #979797                      " }}
                      >
                        Document not found! Please try again.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HistoryListing;
